export const dataTitle = {
    "/": {
        heading: "Overview",
    },
	"/dashboards": {
		heading: "Overview",
	},
	"/classes/e-course": {
		heading: "E-Courses",
	},
	"/classes/tryout": {
		heading: "Try Outs",
	},
	"/classes/classroom": {
		heading: "Classes",
	},
	"/others/reports": {
		heading: "Daftar soal yang Anda laporkan",
	},
	"/others/transactions": {
		heading: "Transactions",
	},
	"/others/account": {
		heading: "Accounts",
	},
	"/others/application-survey": {
		heading: "Application Survey",
	},
};
